<template>
    <div class="tags--select">

        <!--Tag creation-->
        <section v-if="create_modal">
            <div class="modal fade" :id="modal_id" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
                 aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header text-center">
                            <h4 class="modal-title w-100 font-bold">Create Group</h4>
                            <button type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mx-3">
                            <div class="md-form">
                                <input type="text"
                                       :id="input_name__id"
                                       @blur="urlFormat()"
                                       class="form-control"
                                       v-model="input_name__value">
                                <label :for="input_name__id" class="">Ticket Group Name</label>
                            </div>
                        </div>
                        <div class="modal-footer d-flex justify-content-center">
                            <a v-on:click="createTag()"
                               class="btn btn-default">Create</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--Select tags-->
        <section v-show="show_selection==true">
            <div>
                <div id="material_select--wrapper">
                    <material-select ref="tags_chooser_select"
                                     :id="tags_chooser.id"
                                     required="required"
                                     @material_select_result="materialSelectItemSelected"
                                     @material_select_link_click="materialSelectCreateTag"></material-select>
                </div>
            </div>
            <input type="hidden" id="ticket-group-selected" v-model="item_selected">
        </section>
    </div>

</template>

<style>
    #select-icon-type--scrollable-container {
        height: 25vh;
        overflow-y: scroll;
    }
</style>

<script>
    // add imports here
    import {uniqueId} from '../../../helpers/classesAndIds';
    import {_} from 'underscore';
    import MaterialSelect from '../../forms/select/MaterialSelect.vue'
    import {urlFormat} from "../../../urlFormat";

    /**
     * Produces a searchable list of icons to display
     */
    export default {
        components: {
            'material-select': MaterialSelect
        },
        props: [
        	'content'
        ],
        created(){
            this.$on('group_type',(name) => alert(name));
        },
        mounted() {
            this.create_url = this.content._create_url;
            this.read_url = this.content._read_url;
            this.item_selected = this.content._selected;
            this.new_tag_name = this.content._new_tag_name;
            this.loadTags();
            this.$on('group_type',function(){
                console.log('got it');
            })
            // console.log('this.item_selected',this.item_selected);
        },
        data() {
            return {
                show_selection:false,
                modal_id: uniqueId('create--modal-option'),

                input_name__value: '',
                input_slug__value: '',
                new_tag_name: '',
                group_type:'',
                input_name__id: uniqueId('create--input_name__id'),
                input_slug__id: uniqueId('create--input_slug__id'),
                loading: false,
                create_url: '',
                read_url: '',
                tag_create_description: '',
                item_selected: [],
                tags: [],
                tags_chooser: {
                    group_type:'',
                    id: ''
                },
                create_modal: false
            }
        },
        methods: {
            urlFormat() {
                this.input_slug__value = urlFormat(this.input_name__value);

            },
            createTag() {
                let self = this;

                if (self.loading) {
                    return;
                }
                self.loading = true;

                let data = {};
                data[this.new_tag_name] = self.input_name__value;
                data['slug'] = self.input_slug__value;
                data['type']=this.tags_chooser.params.group_type;
                axios.post(self.create_url, data)
                    .then(function (response) {
                        if (response.data.success) {
                            //We did it;
                            $('#' + self.modal_id).modal('hide');
                            console.log(response.data);

                            let new_tag = {
                                id: response.data.tag.id,
                                slug: response.data.tag.slug,
                                lang: response.data.tag.ticket_group_data.lang
                            };

                            self.tags.push(new_tag);

                            self.tags_chooser.select_items = self.tags;
                            self.$refs.tags_chooser_select.addAndSelect(new_tag);
                            self.loading = false;

                            self.create_modal = false;

                        }
                        else {
                            toastr.error('Ops... check all your fields and be sure they are correctly inserted');
                            self.loading = false;
                        }
                    });
            },

            loadTags() {
                let self = this;

                self.loading = true;
                axios.get(self.read_url)
                    .then(function (response) {
                        self.tags = response.data;
                        self.initMaterialSelect([]);
                        self.loading = false;
                    });
            },

            materialSelectCreateTag() {
                let self = this;

                self.create_modal = true;

                self.$nextTick(function () {
                    $('#' + self.modal_id)
                        .on('hidden.bs.modal', function () {
                            self.create_modal = false;
                        })
                        .modal('show');
                });
            },

            materialSelectItemSelected(items) {
                let self = this;
                self.item_selected = [];

                items.forEach(function (item) {
                    self.item_selected.push(item.optionValue);
                });
            },

            initMaterialSelect: function (groups) {
                let self = this;

                self.tags.forEach(function (tag) {
                    if (self.item_selected.indexOf(tag.id) !== -1) {
                        tag.selected = true;
                    }
                });

                self.tags_chooser = {
                    params: {
                        multiple: false,
                       grouped: [],
//                         grouped: groups,
                        group_by: '',
                        top_option: {
                            title: 'Add existing tag'
                        },
                        selected_input_name: 'group_select[]',
                        label: 'Choose ticket group',
                        placeholder: 'No ticket group selected',
                        id: uniqueId('tags_chooser'),
                        link: {
                            add: true,
                            url: '',
                            icon: 'fa-plus',
                            text: 'Create a new tag'
                        },
                    },
                    select_items: self.tags
                };

                self.$root.$emit('material_select', self.tags_chooser);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/ticketing/TicketGroups.vue?28741e03